import { render, staticRenderFns } from "./ImageEffectsPropertiesList.vue?vue&type=template&id=179d4c9f&scoped=true"
import script from "./ImageEffectsPropertiesList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageEffectsPropertiesList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ImageEffectsPropertiesList.vue?vue&type=style&index=0&id=179d4c9f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179d4c9f",
  null
  
)

export default component.exports